export default "__VITE_ASSET__D0hwG31d__"